import submit from "submit-form";

export function submitSort(sort) {
  submit("/actions/refresh", {
    method: "GET",
    body: { sort },
  });
}

export function submitMonth(monthValue) {
  submit("/actions/refresh", {
    method: "GET",
    body: { month: monthValue },
  });
}

export function submitDaysSince(daysSince) {
  submit("/actions/refresh", {
    method: "GET",
    body: { daysSince },
  });
}
